export default "__VITE_ASSET__cElTEXLg__"